const format = (s: string, c: Record<string, string>): string => s.replace(/{(\w+)}/g, (_, p: string) => c[p])

const template = {
  excel:
    '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta name=ProgId content=Excel.Sheet> <meta name=Generator content="Microsoft Excel 11"><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body>{table}</body></html>',
}

const toXLSBlob = (content: string): Blob => {
  const ctx: Record<string, string> = { worksheet: 'Worksheet', table: content }
  const html = format(template.excel, ctx)
  return new Blob([html], { type: 'application/vnd.ms-excel;charset=utf-8' })
}

export default toXLSBlob
